import { gql } from "apollo-boost";
export const GET_TRANSCRIPT = gql`
  query transcript($personId: String, $idGreaterThan: Int, $numberOfRows: Int) {
    transcript(
      personId: $personId
      numberOfRows: $numberOfRows
      idGreaterThan: $idGreaterThan
    ) {
      transcriptId
      fromPerson
      message
    }
  }
`;

export const GET_CLIENT_CONFIG = gql`
  query clientEmbedConfigByClientId($clientId: Int) {
    clientEmbedConfigByClientId(clientId: $clientId) {
      clientEmbedConfigId
      clientId
      clientName
      threadId
      threadName
      introduction
      greeting
      avatar
      isRoundedCorner
      isShowHeader
      themeColor
      isQuiesced
    }
  }
`;

export const GET_HASH = gql`
  query hashId($personId: Int) {
    hashId(personId: $personId) {
      idHash
    }
  }
`;
